import { useSelector } from 'react-redux';
import type React from 'react';
import MarketPreviews from 'app/shared/components/MarketPreviews';
import { emitViewTopMarketEvent } from 'app/shared/constants/MarketTrendsCSEvents';

import type { Market } from 'app/shared/types/Market';
import type { State } from 'app/shared/types/State';

interface TopMarketsProps {
  markets: Array<Market>;
  isSmallScreen: boolean;
  isMobile: boolean;
}

const TopMarkets: React.FunctionComponent<React.PropsWithChildren<React.PropsWithChildren<TopMarketsProps>>> = (
  props,
) => {
  const user = useSelector((state: State) => state.user);
  const { markets, isSmallScreen, isMobile } = props;

  return (
    <MarketPreviews
      markets={markets}
      heading="Median Rent in Select U.S. Markets"
      subject="top markets"
      useFilters
      isSmallScreen={isSmallScreen}
      isMobile={isMobile}
      emitAnalyticsEvent={() => emitViewTopMarketEvent(user)}
    />
  );
};

export default TopMarkets;
